export class ScopedStorage implements Pick<
  Storage,
  'length' | 'key' | 'getItem' | 'setItem' | 'removeItem' | 'clear'
> {
  constructor(
    private readonly inner: Storage,
    private readonly prefix: string,
  ) {}

  get length(): number {
    let n = 0;
    for (let i = 0; i < this.inner.length; i++) {
      const k = this.inner.key(i);
      if (k !== null && k.startsWith(this.prefix)) n++;
    }
    return n;
  }

  key(index: number): string | null {
    let seen = 0;
    for (let i = 0; i < this.inner.length; i++) {
      const k = this.inner.key(i);
      if (k !== null && k.startsWith(this.prefix)) {
        if (seen === index) return k.slice(this.prefix.length);
        seen++;
      }
    }
    return null;
  }

  getItem(key: string): string | null {
    return this.inner.getItem(this.prefix + key);
  }

  setItem(key: string, value: string): void {
    this.inner.setItem(this.prefix + key, value);
  }

  removeItem(key: string): void {
    this.inner.removeItem(this.prefix + key);
  }

  // Collects before removing to avoid index-shift during iteration.
  // Only removes keys within this scope.
  clear(): void {
    const doomed: string[] = [];
    for (let i = 0; i < this.inner.length; i++) {
      const k = this.inner.key(i);
      if (k !== null && k.startsWith(this.prefix)) doomed.push(k);
    }
    for (const k of doomed) this.inner.removeItem(k);
  }
}
